import { connect } from 'react-redux'
import {
  compose, lifecycle, withState, withHandlers,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchCategories, deleteCategory } from 'actions/ContactUsMessages'
import ReviewView from 'components/pages/webManagement/contactUsCategories/List'
import { message } from 'antd'

export function mapStateToProps(state) {
  const { currentUser } = state.root.auth

  return {
    currentUser,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchCategories: bindActionCreators(fetchCategories, dispatch),
  deleteCategory: bindActionCreators(deleteCategory, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('categoyList', 'setCategoryList', {
    data: [],
    meta: {},
    isFetching: true,
  }),
  withHandlers({
    getReviewList: props => () => {
      props.fetchCategories()
        .then((result) => {
          props.setCategoryList({
            data: result.data,
            meta: result.meta,
            isFetching: false,
          })
        })
        .catch((error) => {
          props.setCategoryList({
            data: [],
            meta: {},
            isFetching: false,
          })
          message.error(error.message)
        })
    },
  }),
  withHandlers({
    handleDelete: props => (id) => {
      props.deleteCategory(id)
        .then(() => {
          props.getReviewList()
        })
        .catch((error) => { message.error(error) })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Web Management', 'Contact Us Categories'])
      this.props.updateSiteConfigs({
        titlePage: 'Contact Us Category List',
        activePage: 'web-management/contact-us-categories',
        activeSubPage: 'web-management',
      })
      this.props.getReviewList()
    },
  }),
)(ReviewView)
